import { useEffect } from 'react';
import Confetti from './Confetti';
import { formatMatchMessage } from '../lib/matchEngine';
import { notificationSuccess } from '../lib/haptics';
import { MealIcon } from './MealIcon';
import Avatar from './Avatar';

export default function MatchMoment({ recipe, members, triggerMember, onDone }) {
  useEffect(() => {
    notificationSuccess();
    const timer = setTimeout(onDone, 2800);
    return () => clearTimeout(timer);
  }, [onDone]);

  const hasKidAndAdult = members?.some(m => m.type === 'kid') && members?.some(m => m.type === 'adult');
  const subtitle = triggerMember
    ? `${triggerMember.name.split(' ')[0]} sealed the deal`
    : hasKidAndAdult
      ? 'Kids and adults aligned on this one'
      : 'Whole family is in';

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center animate-match-fade"
      onClick={onDone}
      role="dialog"
      aria-label="It's a match!"
    >
      <div className="absolute inset-0 bg-surface/85 backdrop-blur-sm" />
      <Confetti count={56} />
      <div className="relative z-10 text-center px-6 max-w-sm animate-match-pop">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-match-500/25 ring-4 ring-match-400 mb-4 text-match-500">
          <MealIcon meal={recipe?.category} className="w-10 h-10" />
        </div>
        <p className="font-display text-3xl font-semibold text-white tracking-tight">
          It&apos;s a match!
        </p>
        <p className="font-body text-sm text-white/80 mt-2 leading-relaxed">
          {recipe ? formatMatchMessage(recipe).replace(/^It's a match! /, '') : 'Whole family aligned'}
        </p>
        <p className="font-body text-xs text-match-400 mt-1">{subtitle}</p>

        {members?.length > 0 && (
          <div className="mt-5 flex items-center justify-center -space-x-2">
            {members.map(m => (
              <div
                key={m.id}
                className="w-10 h-10 rounded-full bg-panel text-lg flex items-center justify-center ring-2 ring-match-400 shadow-sm overflow-hidden"
                title={m.name}
              >
                <Avatar url={m.avatar_url} fallback={m.avatar} name={m.name} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
